<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3b"><a id="page_10"></a><a id="ch5"></a><em>Dry Time</em></h3>
<p class="noindent">Killed, the sand</p>
<p class="noindent">didn’t give. All waves</p>
<p class="noindent">went dead: your border</p>
<p class="noindent">crossed itself.</p>
<p class="noindentt">I couldn’t tell or tear</p>
<p class="noindent">us apart. In the absence</p>
<p class="noindent">of hourglasses</p>
<p class="noindent">meanwhiles</p>
<p class="noindentt">piled up, swells of the</p>
<p class="noindent">dispellable. Even the diamond</p>
<p class="noindent">shed no oil, not a drop</p>
<p class="noindent">to delight the drilltip.</p>
<p class="image"><img alt="common.jpg" src="images/common.jpg"/></p>
<p class="noindentt">Partners having come</p>
<p class="noindent">unwelded (blasted by nuclear</p>
<p class="noindent">family life) we went</p>
<p class="noindent">a long</p>
<p class="noindentt">way back,</p>
<p class="noindent">as far as Abacus (empire of</p>
<p class="noindent">the rook and stork). We roused</p>
<p class="noindent">some dowsers</p>
<p class="noindentt">from a timeless doze, we had them</p>
<p class="noindent">scatter Onan’s</p>
<p class="noindent">nanoseconds</p>
<p class="noindent">everywhere: in waves and particles, the clearest</p>
<p class="noindentt">solitudes could be</p>
<p class="noindent">broadcast. At last</p>
<p class="noindent">you kissed me, I</p>
<p class="noindent">could die again, and one</p>
<p class="noindentt">good lick</p>
<p class="noindent">of quicksand</p>
<p class="noindent">took . . .</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter05.vue?25da942a